module.exports = __webpack_public_path__ + "img/人脸识别机.5a581158.png";